<template>
  <div class="e-block-wrap">
    <div class="e-block">
      <div class="e-block__scroll" :style="{ minHeight: containerHeight }">
        <div class="e-block__title">Section under development</div>
      </div>
    </div>
    <div class="e-bottom-navbar">
      <div class="e-row">
        <div class="e-col-auto e-col-sm-6">
          <button class="e-btn e-btn--prev" @click.prevent="previous">Previous</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  components: {},
  name: 'Placeholder',
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState(['containerHeight']),
  },
  methods: {
    ...mapActions(['previousQuestion']),
    previous() {
      this.previousQuestion();
    },
  },
};
</script>

<style lang="scss">

</style>
